import { Typography } from '@spotnana/blocks/src/Typography/Typography';
import { Row } from './styles';

interface IProps {
  label: string;
  value: string;
}

const Heading = ({ label, value }: IProps) => {
  return (
    <Row data-testid="fare-breakup-row">
      <Typography variant="header4" as="dt">
        {label}
      </Typography>
      <Typography variant="header4" as="dd">
        {value}
      </Typography>
    </Row>
  );
};

export default Heading;
